import { useState } from "react";
import KitchenStaffOnboard from "@/components/mobile/KitchenStaffOnboard";
import { loadSavedKitchenStaffPhone } from "@/lib/kitchenStaff";
import { staffLoginPath } from "@/lib/teamHub";

const PINK = "#EE2677";

/** Phone login or one-time sign-up — same flow as DA delivery partners. */
export default function KitchenStaffAuthGate({ onComplete, initialMode = "login" }) {
  const [mode, setMode] = useState(initialMode);
  const [phone] = useState(() => loadSavedKitchenStaffPhone());
  const [err, setErr] = useState("");

  if (mode === "signup") {
    return (
      <KitchenStaffOnboard
        initialPhone={phone}
        onComplete={onComplete}
        onCancel={() => {
          setMode("login");
          setErr("");
        }}
      />
    );
  }

  return (
    <div className="ka-staff-auth">
      <style>{`
        .ka-staff-auth {
          min-height: 100dvh; background: #F5F2EA; color: #2D2D2D;
          padding: 12px 14px 28px; max-width: 480px; margin: 0 auto;
          font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
        }
        .ka-staff-auth * { box-sizing: border-box; }
        .ka-staff-brand { text-align: center; margin: 24px 0 28px; }
        .ka-staff-brand-kicker {
          font-size: 11px; font-weight: 800; letter-spacing: 0.12em;
          text-transform: uppercase; color: rgba(45,45,45,0.45); margin: 0 0 4px;
        }
        .ka-staff-brand-name { font-size: 28px; font-weight: 900; color: ${PINK}; margin: 0; }
        .ka-staff-card {
          background: #fff; border-radius: 20px; padding: 20px 18px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.06);
        }
        .ka-staff-title { font-size: 20px; font-weight: 800; margin: 0 0 6px; }
        .ka-staff-sub { font-size: 14px; color: rgba(45,45,45,0.65); margin: 0 0 16px; line-height: 1.45; }
        .ka-staff-field label { display: block; font-size: 13px; font-weight: 700; margin-bottom: 6px; }
        .ka-staff-field input {
          width: 100%; border: 2px solid #E5E7EB; border-radius: 14px;
          padding: 14px; font-size: 18px; background: #fff;
        }
        .ka-staff-primary {
          width: 100%; border: none; border-radius: 16px; padding: 16px;
          font-size: 17px; font-weight: 800; color: #fff; background: ${PINK};
          cursor: pointer; margin-top: 14px;
        }
        .ka-staff-primary:disabled { opacity: 0.6; cursor: wait; }
        .ka-staff-link {
          width: 100%; margin-top: 12px; border: none; background: transparent;
          color: ${PINK}; font-size: 15px; font-weight: 800; cursor: pointer; padding: 10px;
        }
        .ka-staff-note {
          margin-top: 16px; background: #FFF7FA; border: 1px solid #F9A8D4;
          border-radius: 14px; padding: 12px; font-size: 13px; font-weight: 600;
          text-align: center; line-height: 1.45; color: #831843;
        }
        .ka-staff-err { color: #B91C1C; font-size: 14px; font-weight: 600; margin-top: 10px; }
      `}</style>

      <div className="ka-staff-brand">
        <p className="ka-staff-brand-kicker">Kitchen app</p>
        <h1 className="ka-staff-brand-name">The Table Top</h1>
      </div>

      <div className="ka-staff-card">
        {/* Reaching this means signed in but without Kitchen access — no login
            form, because a phone number is no longer a credential and sending
            them back to the staff login they just came from would loop. */}
        <h2 className="ka-staff-title">Kitchen access not granted</h2>
        <p className="ka-staff-sub">
          Aap staff login se aa gaye ho, par abhi Kitchen app ka access nahi hai.
          Manager se approve karwa lo.
        </p>
        {err ? <p className="ka-staff-err">{err}</p> : null}
        <button type="button" className="ka-staff-primary" onClick={() => window.location.assign(staffLoginPath("/pp/hub"))}>
          Staff login
        </button>
        <button type="button" className="ka-staff-link" onClick={() => { setMode("signup"); setErr(""); }}>
          New team member? Sign up here
        </button>
        <div className="ka-staff-note">
          Start / Done timing ab aapke naam se save hogi — learning ke liye sahi person track hoga.
        </div>
      </div>
    </div>
  );
}
